import { yupResolver } from "@hookform/resolvers/yup";
import { array, number, object, string } from "yup";

const schema = object({
  business_name: string().label("Business Name").required(),
  risk_members_days_from_last_visit: number().label("Days from the last visit").required(),
  risk_members_days_prev_last_visit: number().label("Days previous to the last visit").required(),
  membership_calculation_agreement_types: array()
    .min(1, "Please choose at least 1 agreement type")
    .label("Membership agreement/club type")
    .required()
}).required();

export const unregisterFields = ({ unregister, showFutureAppointments, membershipMetric }) => {
  if (!showFutureAppointments) {
    unregister("show_future_appointments_by_default", { keepDefaultValue: true });
  }

  if (membershipMetric.id === "NumberOfMembersByProfile") {
    unregister("membership_start", { keepDefaultValue: true });
  }

  if (
    membershipMetric.id === "NumberOfPayingMembersByPricingOption" ||
    membershipMetric.id === "NumberOfPayingMembersByPricingOptionExcludingZeroSales"
  ) {
    unregister("exclude_frozen_members_from_total_members_count", { keepDefaultValue: true });
  }
};

export const filterByValue = (arr, val) => arr.find((el) => el.id === val);

export const mapByName = (arr) => arr.map((item) => ({ name: item }));

export function filterByDefault(arr, paramName = "isSelected") {
  return arr.filter((item) => item[paramName]);
}

export const schemaResolver = yupResolver(schema);
